<template>
  <div>

    <div class="components_select">
      <el-select v-model="select_value" :placeholder="placeholder_select" clearable @change="cascaderChange">
        <el-option
            v-for="item in options"
            :key="item[select_key]"
            :label="item[select_label]"
            :value="item[select_key]">
        </el-option>
      </el-select>
      <el-input prefix-icon="el-icon-search" v-model="search_input" :placeholder=placeholder_input
                @input="input_value"></el-input>
      <el-button type="primary" @click="query">{{ langSet == 'cn' ? '查询' : 'query' }}</el-button>
    </div>
    <div class="label_box">
      <div :class="['label_bottom',item_index==index?'label_change':'']" v-for="(item,index) in label_list" :key="index"
           @click="label_change(item,index)">{{ langSet == 'cn' ? item.name : item.name_en }}
      </div>
    </div>


    <div class="fitter_box">
      <el-input prefix-icon="el-icon-search" v-model="search_input" :placeholder=placeholder_input
                @input="input_value"></el-input>

      <div class="box_flex">
        <div>
          <el-select v-model="select_value" :placeholder="placeholder_select" clearable @change="cascaderChange">
            <el-option
                v-for="item in options"
                :key="item[select_key]"
                :label="item[select_label]"
                :value="item[select_key]">
            </el-option>
          </el-select>
        </div>
        <div v-if="type!=='liveEvents'">
          <el-select v-model="label_value" :placeholder="placeholder_select" @change="label_change" >
            <el-option
                v-for="item in label_list"
                :key="item.value"
                :label="langSet == 'cn' ? item.name : item.name_en "
                :value="item.value">
            </el-option>
          </el-select>
        </div>
          <el-button type="primary" @click="query">{{ langSet == 'cn' ? '查询' : 'query' }}</el-button>
      </div>

    </div>


  </div>
</template>

<script>
export default {
  name: "Select_input_search",
  props: ['type','placeholder_select', 'placeholder_input', 'options', 'select_key', 'select_label', 'label_list'],
  data() {
    return {
      langSet: localStorage.getItem("languageSet") || "cn",
      search_input: '',
      select_value: '',
      label_value: '',
      item_index: 0
    }

  },
  mounted() {
    this.label_value=this.label_list[0].value
  },
  methods: {
    cascaderChange() {
      this.query()
    },
    label_change(item, index) {
      if(index+1>0){
        this.label_value = item.value
        this.item_index = index
      }
      this.query()
    },
    query() {
      let data = {
        select_value: this.select_value,
        search_input: this.search_input,
        pageNo: 1,
        label_value: this.label_value
      }
      this.$emit('query_change', data);
    },
    input_value(e) {
      if (e.length == 0) {
        this.query()
      }
    }
  }
}
</script>


<style scoped lang="scss">
.fitter_box{
  display: none;
}
.components_select {
  display: flex;

  /deep/ .el-input--suffix .el-input__inner {
    background: #F7F8FA;
    border: none;
  }

  /deep/ .el-input--prefix {
    margin: 0 15px;
  }

  /deep/ .el-button--primary {
    background-color: #004190;
    border-color: #004190;
    width: 120px;
  }


}
.label_box {
  display: flex;
  align-items: center;
  justify-content: left;

  .label_bottom {
    cursor: pointer;
    width: 142px;
    height: 50px;
    background: #F7F8FA;
    border-radius: 25px;
    font-weight: 400;
    font-size: 18px;
    color: #999999;
    text-align: left;
    font-style: normal;
    margin-right: 15px;
    margin-top: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
  }


  .label_change {
    background: #004190;
    color: #ffffff;
  }
}
@media only screen and (max-width: 767px) {
  .components_select {
    display: none;
  }
  .label_box {
    display: none;
  }
  .fitter_box {
    display: initial;
    .box_flex{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 0.19rem ;
      div:nth-child(1) {
        width: 2.4rem;
      }
      div:nth-child(2) {
        width: 2.4rem;
      }
      div:nth-child(3) {
        //width: 1.73rem;
      }
      /deep/ .el-button--primary {
        background-color: #004190;
        border-color: #004190;
      }
    }

  }

}


</style>